// Standalone config module — MUST NOT import from other shared modules.
// map.ts / world.ts import from here; importing from "./index" instead would
// create a circular import that crashes ESM bundles (TDZ ReferenceError).
// 게임 서버 주소는 클라이언트가 접속 환경에 따라 자동 판별한다
// (packages/client/src/serverUrl.ts) — 여기엔 두지 않는다.
export const GAME_CONFIG = {
  TILE_SIZE: 16,
  MAP_COLS: 50,
  MAP_ROWS: 40,
  PLAYER_SPEED: 160,
} as const;
